export default {
  user: 'Username',
  password: 'Password',
  passwordConfirmation: 'Password confirmation',
  login: 'Log in',
  logout: 'Log out',
  heading: 'Login',
  register: 'Register',
  registerButton: 'Sign up',
  confirmEmailHeader: 'Confirm e-mail address',
  confirmEmail: 'Your account is not activated. To activate - check your e-mail box and confirm registration.',
  name: 'Name and surname',
  email: 'E-mail',
  text: 'The Nutricia Copacking platform was created for customers who will be able to quickly and easily find the price for the type of repackage they are interested in.',
  forgotPassword: 'If you want to recover password',
  error: {
    server: 'Error. Please try again later.',
    token: 'Invalid token',
    login: 'Login details incorrect!',
    email: 'The entered e-mail address is incorrect!',
    password: 'The password field cannot be empty!',
    passwordConfirmation: 'Passwords do not match.',
    passwordMinLength: 'The entered password is too short!',
    name: 'The name field cannot be empty!',
  },
  domainRegister: 'If you already have an e-mail in @danone.com domain',
  contactAdministrator: 'If you do not have email in @danone.com domain, contact with administrator',
  backToLogin: 'Back to log in',
  confirmYourEmail: 'After successful register, you will receive an e-mail, which you need to confirm to activate account.',
  clickHere: 'click here',
  forgotPasswordHeader: 'Forgot password',
  forgotPasswordMessage: 'Password reset request was sent successfully. Please check your email to reset your password.',
  send: 'Send',
  resetPasswordHeader: 'Reset password',
  resetPasswordMessage: 'Your password has been changed successfully',
  resetPasswordRedirect: 'Go to log in',
  invalidToken: 'Your reset password link is no longer valid. You can request another one below.',
};
